import {h, Fragment} from "preact"
import { useProductFilters } from '@nosto/preact'

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    const formatPrice = (value) => {
        const [min, max] = value.split('-').map((v) => parseInt(v.trim(), 10))
        return `£${min.toLocaleString()} - £${max.toLocaleString()}`
    }

    return (
        filters.length > 0 && (
            <div class="active-facets justify-center">
                {filters.map((filter) => (
                    <div class="removable-facet" key={`${filter.name}: ${filter.value}`}>
                        <div>
                            <a
                                href="javascript:void(0)"
                                class="tap-area link-faded"
                                aria-label='Remove filter"'
                                onClick={() => filter.remove()}
                            >
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    fill="none"
                                    width="10"
                                    class="icon icon-close"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="m1 1 14 14M1 15 15 1"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                    ></path>
                                </svg>
                            </a>
                        </div>
                        <span class="text-subdued">
                            {filter.name === 'Price'
                                ? formatPrice(filter.value)
                                : filter.name === 'Available'
                                ? 'In stock'
                                : filter.value}
                        </span>
                    </div>
                ))}
                {filters.length > 1 && (
                    <div>
                        <a
                            href="javascript:void(0)"
                            class="facets-clear-all text-subdued"
                            onClick={() => {
                                removeAll()
                            }}
                        >
                            <span class="link">Clear all</span>
                        </a>
                    </div>
                )}
            </div>
        )
    )
}
